import { get, post, put } from "../Service/ApiConfig";
import { ApiEndpoints, DoctorAssistantEndPoint} from "../Service/Endpoints/ApiEndPoints";

export const createDoctorAssistant = async ({ doctorassistant }) => {
  const response = await post(
    DoctorAssistantEndPoint.createDoctorAssistant,
    JSON.stringify(doctorassistant),
  );
  return response;
};

export const getAllDoctorsAssistant = async ({ page, size, searchText, language }) => {
  const response = await get(
    DoctorAssistantEndPoint.getAllDoctorsAssistant(page, size, searchText, language),
  );
  return response;
};

export const getDoctorAssistantByID = async ({ id,lang }) => {
  const response = await get(DoctorAssistantEndPoint.getDoctorAssistantByID(id,lang));
  return response;
};

export const getDoctorAssistantFullDetailsByID = async (id, lang) => {
  const response = await get(DoctorAssistantEndPoint.getDoctorFullDetailsByID(id, lang));
  return response;
};

export const verifyDoctorByID = async (id) => {
  const response = await put(DoctorAssistantEndPoint.verifyDoctorByID(id));
  return response;
};

export const updateDoctorAssistant = async ({ doctorAssistant }) => {
  const response = await put(
    DoctorAssistantEndPoint.updateDoctorAssistant,
    JSON.stringify(doctorAssistant),
  );
  return response;
};

/**
 * * this method will activate or inactivate a doctor
 * @param id => get the id of the doctor
 * @param activeStatus => get the active status of the doctor
 * @return response => server response
 */
export const activationStatDoctorAssistant = async ({ id, activeStatus }) => {
  const response = await put(
    DoctorAssistantEndPoint.ActivationDoctorAssistant,
    JSON.stringify({
      id: id,
      isActivate: activeStatus,
    }),
  );

  return response;
};

export const resetUserRetryCount = async (email) => {
  const response = await put(ApiEndpoints.resetUserRetryCount(email));
  return response;
}

export const searchDoctorAssistant = async (search) => {
  const response = await get(DoctorAssistantEndPoint.searchDoctors(search));
  return response;
};

export const resendResetPasswordLink = async ({ userId }) => {
  const response = await post(
    DoctorAssistantEndPoint.resendPasswordLink,
    JSON.stringify({ uuid: userId }),
  );
  return response;
};

export const blockDocByUserCode = async ({ docId, status, id }) => {
  const response = await put(
    DoctorAssistantEndPoint.blockDoctor,
    JSON.stringify({ uuid: docId, status: status, id: id }),
  );
  return response;
};
